import type { ExportProfile } from '../../../shared/export';
import { normalizeProfile } from '../../../shared/export';
import { apiFetch } from './api';
import { getDb } from './db';

/** The Salesforce export mapping (D91) on the device: the sync keeps a copy so the day's block and
 *  CSV can be made with no signal, and an edit goes to the server the way the templates do. */

const KEY = 'export_profile';

export const keepExportProfile = async (profile: ExportProfile): Promise<void> => {
  await (await getDb()).put('meta', { key: KEY, value: profile });
};

/** The mapping as the last sync left it, or the defaults on a device that has never synced. */
export const loadExportProfile = async (): Promise<ExportProfile> => {
  const row = await (await getDb()).get('meta', KEY);
  return normalizeProfile((row?.value as Partial<ExportProfile> | undefined) ?? null);
};

/** Saving needs the network (the mapping is one row for the account, like the templates); the copy
 *  on the device is only replaced once the server has taken it. */
export const saveExportProfile = async (profile: ExportProfile): Promise<ExportProfile> => {
  const saved = await apiFetch<ExportProfile>('PUT', '/api/activity/fields', profile);
  await keepExportProfile(saved);
  return saved;
};
